import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import CardTable from "../../../components/AdminTable/CardTable";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { FaEye, FaTrash } from "react-icons/fa";
import DeleteModal from "../../../components/Modal/DeleteModal";

export default function CustomerFeedbackView() {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  // const navigate = useNavigate();

  // Fetch all feedbacks
  const fetchFeedbacks = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiKey}/api/customer-feedbacks`);
      setFeedbacks(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast.error("Failed to load feedbacks");
      setFeedbacks([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  // Delete feedback
  const handleDelete = (id) => {

    setDeletingId(id);
    try {
      axios.delete(`${apiKey}/api/customer-feedbacks/${id}`);
      toast.success("Feedback deleted successfully");
      setFeedbacks(feedbacks.filter((f) => f.id !== id));
    } catch (err) {
      toast.error("Failed to delete feedback");
    } finally {
      setDeletingId(null);
    }
  };

  // Open view modal
  const openViewModal = (feedback) => {
    if (!feedback) return;
    setSelectedFeedback(feedback);
    setViewModal(true);
  };

  // Table columns
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Name"),
      accessorKey: "Name",
      cell: (row) => row.row.original?.Name ?? "-",
    },
    {
      header: languageHelper("Email"),
      accessorKey: "Email",
      cell: (row) => row.row.original?.Email ?? "-",
    },
    {
      header: languageHelper("Phone"),
      accessorKey: "Phone",
      cell: (row) => row.row.original?.Phone ?? "-",
    },
    {
      header: languageHelper("Date"),
      accessorKey: "Date",
      cell: (row) => row.row.original?.Date ?? "-",
    },
    {
      header: languageHelper("Added By"),
      accessorKey: "AddedBy",
      cell: (row) => row.row.original?.AddedBy ?? "-",
    },
    {
      header: languageHelper("Actions"),
      accessorKey: "actions",
      cell: (row) => (
        <Dropdown id={row.row.original?.id} options={dropdownOptions} />
        // <div className="flex gap-2">
        //   <button
        //     onClick={() => openViewModal(row.row.original)}
        //     className="px-3 py-1 bg-purple-600 text-white rounded hover:bg-purple-700"
        //   >
        //     View
        //   </button>
        //   <button
        //     onClick={() => handleDelete(row.row.original?.id)}
        //     disabled={deletingId === row.row.original?.id}
        //     className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
        //   >
        //     {languageHelper("Delete")}
        //   </button>
        // </div>
      ),
    },
  ];

  const dropdownOptions = [
    {
      name: languageHelper("View"),
      icon: <FaEye />,
      func: (id) => {
        const row = feedbacks.find((f) => f.id === id);
        openViewModal(row)
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrash />,
      func: (id) => setDeletingId(id),
    }
  ]

  const buttonData = [
    { buttonText: languageHelper("Add Feedback"), path: "addCustomerFeedbackForm" },
  ];

  return (
    <main>
      <CardTable
        data={feedbacks}
        columns={columns}
        heading={languageHelper("Customer Feedbacks")}
        buttonData={buttonData}
        loading={loading}
      />

      {/* View Modal */}
      {viewModal && selectedFeedback && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-8 rounded-2xl shadow-xl max-w-lg w-full overflow-y-auto max-h-[90vh] relative">
            <h3 className="text-2xl font-bold mb-4 text-purple-600">
              Feedback from {selectedFeedback?.Name ?? "-"}
            </h3>

            <div className="mb-4">
              <p>
                <span className="font-semibold">Email:</span>{" "}
                {selectedFeedback?.Email ?? "-"}
              </p>
              <p>
                <span className="font-semibold">Phone:</span>{" "}
                {selectedFeedback?.Phone ?? "-"}
              </p>
              <p>
                <span className="font-semibold">Date:</span>{" "}
                {selectedFeedback?.Date ?? "-"}
              </p>
              <p>
                <span className="font-semibold">Added By:</span>{" "}
                {selectedFeedback?.AddedBy ?? "-"}
              </p>
            </div>

            <div className="border-t border-gray-200 pt-4">
              <h4 className="text-xl font-semibold mb-2 text-gray-700">
                Feedback Details:
              </h4>

              {selectedFeedback?.feedbacks &&
                selectedFeedback.feedbacks.length > 0 ? (
                selectedFeedback.feedbacks.map((fb, idx) => (
                  <div
                    key={idx}
                    className="mb-3 p-3 bg-gray-50 rounded-lg shadow-sm"
                  >
                    <p className="font-medium text-gray-800">
                      {fb.question || `Answer ${idx + 1}`}
                    </p>
                    <p className="text-gray-700 mt-1">{fb.answer ?? fb}</p>
                  </div>
                ))
              ) : (
                <p className="text-gray-500">{languageHelper("No detailed feedback available")}</p>
              )}
            </div>

            <button
              className="mt-4 px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition"
              onClick={() => setViewModal(false)}
            >
              {languageHelper("Close")}
            </button>
          </div>
        </div>
      )}

      {deletingId && (
        <DeleteModal
          setIsOpen={setDeletingId}
          onDelete={() => handleDelete(deletingId)}
        />
      )}
    </main>
  );
}
